import React, { useRef } from 'react';
import { useNavigate } from 'react-router-dom';
import './Footer.css';

const Footer = () => {
  const navigate = useNavigate();
  const clickTimes = useRef([]);

  const handleSecretClick = (event) => {
    event.preventDefault();

    const now = Date.now();

    clickTimes.current.push(now);

    /* Below allows you set the timing for which the three clicks must happen */

    clickTimes.current = clickTimes.current.filter(
      (time) => now - time <= 1000
    );

    if (clickTimes.current.length === 3) {

      clickTimes.current = [];
      navigate('/gallery');
    }
  };

  const handleContextMenu = (event) => {
    event.preventDefault();
  };

  const handleMouseDown = (event) => {
    if (event.button === 1) {
      event.preventDefault();
    }
  };

  const handleModifiedClick = (event) => {
    if (event.ctrlKey || event.metaKey) {
      event.preventDefault();
      event.stopPropagation();
    }
  };

  return (
    <footer className="footer">
      <div className="footer-section footer-contact">
        <p className="footer-heading">Contact me</p>
        <p className="footer-name">Emeka Aniekwensi</p>

        <div className="footer-email-list">
          

          <a
            className="email-link"
            href="https://mail.google.com/mail/?view=cm&fs=1&to=aniekwen@msu.edu"
            target="_blank"
            rel="noopener noreferrer"
          >
            aniekwen@msu.edu
          </a>

          <a
            className="email-link"
            href="https://mail.google.com/mail/?view=cm&fs=1&to=felixaniekwensi@gmail.com"
            target="_blank"
            rel="noopener noreferrer"
          >
            felixaniekwensi@gmail.com
          </a>

          <a
            className="email-link"
            href="https://mail.google.com/mail/?view=cm&fs=1&to=efa2621@jagmail.southalabama.edu"
            target="_blank"
            rel="noopener noreferrer"
          >
            efa2621@jagmail.southalabama.edu
          </a>

          <a
            className="email-link"
            href="https://mail.google.com/mail/?view=cm&fs=1&to=drainage.event.separator@gmail.com"
            target="_blank"
            rel="noopener noreferrer"
          >
            drainage.event.separator@gmail.com
          </a>
        </div>
      </div>

      <div className="footer-section">
        <p className="footer-heading">Follow me</p>

        <div className="footer-social-links">
          <a
            href="https://www.linkedin.com/in/emeka-aniekwensi-83a84620a/"
            target="_blank"
            rel="noopener noreferrer"
          >
            LinkedIn
          </a>

          <a
            href="https://github.com/jorelix/"
            target="_blank"
            rel="noopener noreferrer"
          >
            GitHub
          </a>
        </div>
      </div>

      <div className="footer-section footer-license">
        <p>
          Copyright &copy; {new Date().getFullYear()} Emeka Aniekwensi.
          <br />
          Released under the MIT License
          <a
            href="/gallery"
            className="gallery-link"
            aria-label="Open gallery"
            onClick={handleSecretClick}
            onClickCapture={handleModifiedClick}
            onContextMenu={handleContextMenu}
            onMouseDown={handleMouseDown}
          >
            <span aria-hidden="true">&#9733;</span>
          </a>
        </p>
      </div>
    </footer>
  );
};





export default Footer;